<div class="page-container p-0 dashboard">
  <div class="container-fluid">
    <h1 class="h1 welcome">Hello, {{brokerInfo && brokerInfo.brokerName || '--'}}</h1>

    <h1 class="h1">
      Daily Market Update <br/>
      <span class="date">{{currentDate | date: "MMMM d, y"}}</span><br/>
      <em>Updates Mon-Fri at 7AM Central Time</em>
    </h1>
    <div class="row bottom-line">
<!--      <div class="col-sm-12 date">-->
<!--        Today's Date {{currentDate | date: "dd/MM/YYYY"}}-->
<!--      </div>-->
<!--      <div class="col-sm-12 item">-->
<!--        <h3 class="h3">Wholesale Power Monthly Settlements</h3>-->
<!--      </div>-->
      <div class="col-sm-12 col-lg-6 item">
        <h3 class="h3 mb-0">Day-over-Day Change in ATC Forward Power Prices</h3>
<!--        <div fxLayout="row" fxLayoutAlign="center center" class="p-2">-->
<!--          <strong>Observation Date:&#x00A0;</strong> {{powerObservationDate | date: "YYYY-MM-dd"}}-->
<!--          Updates at 7:00 am and 7:00 pm CT, Monday through Friday-->
<!--        </div>-->
        <app-market-table marketType="power" (dataEmit)="powerObservation($event)"></app-market-table>
      </div>
      <div class="col-sm-12 col-lg-6 item" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-around center">
          <mat-select fxFlex="25" class="filterDropdown" placeholder="Select Node" [value]="nodeValue" (selectionChange)="distinctNodeChange($event)">
            <ng-container *ngFor="let option of distinctNodes">
              <mat-option [value]="option">
                {{option}}
              </mat-option>
            </ng-container>
          </mat-select>
          <h3 class="h3 ml-2" fxFlex="50">ATC Forward Power Prices</h3>
          <span fxFlex="25"></span>
        </div>
        <app-line-chart fxFlex="1 0 0" [graphData]="powerGraphData" [loading]="powerGraphLoading" yAxisLabel="Price ($/MWh)" xAxisLabel="Observation Date" xAxisType="datetime"></app-line-chart>
      </div>
    </div>
    <div class="row">
      <!--      <div class="col-sm-12 date">-->
      <!--        Today's Date {{currentDate | date: "dd/MM/YYYY"}}-->
      <!--      </div>-->
<!--      <div class="col-sm-12 item">-->
<!--        <h3 class="h3">NYMEX Natural Gas Monthly Settlements</h3>-->
<!--      </div>-->
      <div class="col-sm-12 col-lg-6 item">
        <h3 class="h3">Day-over-Day Change in Natural Gas Future Prices</h3>
<!--        <div fxLayout="row" fxLayoutAlign="center center" class="p-2">-->
<!--          <strong>Observation Date:&#x00A0;</strong> {{gasObservationDate | date: "YYYY-MM-dd"}}-->
<!--          Updates at 7:00 am and 7:00 pm CT, Monday through Friday-->
<!--        </div>-->
        <app-market-table marketType="gas" (dataEmit)="gasObservation($event)"></app-market-table>
      </div>
      <div class="col-sm-12 col-lg-6 item">
        <h3 class="h3">NYMEX Natural Gas Monthly Settlements</h3>
        <app-line-chart [graphData]="gasGraphData" yAxisLabel="Price ($/MMBtu)" xAxisLabel="Start Date"></app-line-chart>
      </div>
    </div>
<!--    <h2 class="h2">Hot Deals</h2>-->
    <div class="row">
      <div class="col-sm-12 item">
        <app-active-quote [showOnlyFavorites]="true" [showSearchBar]="false" appTitle="Favorite Active Quotes" titleAlign="center"></app-active-quote>
      </div>
      <div class="col-sm-12 item footer-text d-none">
        <h2 class="btn-grp-head">Reporting</h2>
        <div class="dashboard-btn-group" fxLayout="row" fxLayoutAlign="center space-between">
          <button class="dashboard-btn" color="primary" type="button" mat-raised-button>Account Status</button>
          <button class="dashboard-btn" color="primary" type="button" mat-raised-button (click)="openPaidCommissionsDialog()">Paid Commissions</button>
          <button class="dashboard-btn" color="primary" type="button" mat-raised-button>Contract Expiration</button>
        </div>
<!--        <div>-->
<!--          <span class="content">Need technical assistance or for general comments or suggestions to improve portal?</span>-->
<!--          <span class="email">Email <a href="mailto: brokerportal@freepointsolutions.com">brokerportal@freepointsolutions.com</a></span>-->
<!--        </div>-->
      </div>
      <div class="col-sm-12 footer-text-2">
        <div class="mb-2 mt-2" fxLayout="row" fxLayoutAlign="center center">
          <button class="contact-btn" color="primary" type="button" mat-raised-button (click)="openContactInfo()">Contact Us</button>
        </div>
      </div>
    </div>
  </div>
  <app-dashbaord-footer></app-dashbaord-footer>
</div>
